<template>
  <layout-default-filters @open="$_OnOpen" @apply="$_applyQueryString" :hideButton="false">
    <template #superior>
    <div class='div-geral'>
      
      <div class='primeiro-filtro'>
        <v-form ref="form" >
          <!-- <core-text-field
            clearable
            v-model="filters.cidade"
            label='Endereço / Cidade'
            @keydown="bloquearCaracteresInvalidos"
            placeholder="Filtrar por endereço..."
          /> -->

          <div class="mt-4 px-1">
            <span class="subtitle-2 font-weight-bold grey--text text--darken-2">Filtrar por Tipo:</span>
            <v-radio-group v-model="filters.tipo" class="mt-2" hide-details>
              <v-row dense>
                <v-col cols="12" class="py-0 mb-2">
                  <v-radio label="Todos" value="TODOS"></v-radio>
                </v-col>
                <v-col cols="6" class="py-0">
                  <v-radio label="Fornecedor" value="FR"></v-radio>
                </v-col>
                <v-col cols="6" class="py-0">
                  <v-radio label="Representante" value="RP"></v-radio>
                </v-col>
                <v-col cols="6" class="py-0">
                  <v-radio label="Transportador" value="TP"></v-radio>
                </v-col>
                <v-col cols="6" class="py-0">
                  <v-radio label="Diversos" value="DV"></v-radio>
                </v-col>
                <v-col cols="6" class="py-0">
                  <v-radio label="Motorista" value="MT"></v-radio>
                </v-col>
                <v-col cols="6" class="py-0">
                  <v-radio label="Prestadores" value="PR"></v-radio>
                </v-col>
                <v-col cols="6" class="py-0">
                  <v-radio label="Funcionário" value="FC"></v-radio>
                </v-col>
              </v-row>
            </v-radio-group>
          </div>

        </v-form>
      </div>
    </div>
    </template>
  </layout-default-filters>
</template>

<script>
import { setQueryValue } from '@/services/query-string';
import LayoutDefaultFilters from '@/layouts/default/NewFilters.vue';
// import CoreTextField from '@/components/core/text-field/Index.vue';

export default {
  name: 'ViewPesquisaFornecedorFilters',

  components: {
    LayoutDefaultFilters,
    // CoreTextField,
  },

  data() {
    return {
      filters: {
        cidade: null,
        tipo: 'FR',
      },
    };
  },

  methods: {
    bloquearCaracteresInvalidos(e) {
      if (['-', '+'].includes(e.key)) {
        e.preventDefault();
      }
    },

    $_applyQueryString() {
      setQueryValue('cidade', this.filters.cidade || null);
      setQueryValue('tipo', this.filters.tipo || null);
    },

    $_OnOpen() {
    },
  },

  watch: {
    $route: {
      deep: true,
      immediate: true,
      handler() {
        this.filters.cidade = this.$route.query.cidade || null;
        
        let tipoUrl = this.$route.query.tipo;
        
        if (tipoUrl === undefined) {
          this.filters.tipo = 'FR';
        } else {
          tipoUrl = tipoUrl ? String(tipoUrl).toUpperCase() : '';
          
          const mapaTipos = {
            'FORNECEDOR': 'FR',
            'REPRESENTANTE': 'RP',
            'TRANSPORTADOR': 'TP',
            'DIVERSOS': 'DV',
            'MOTORISTA': 'MT',
            'PRESTADORES': 'PR',
            'FUNCIONARIO': 'FC',
            'FUNCIONÁRIO': 'FC',
            'TODOS': 'TODOS'
          };

          this.filters.tipo = mapaTipos[tipoUrl] || tipoUrl;
        }
      },
    },

    'filters.tipo': {
      immediate: true,
      handler() {
        this.$_applyQueryString();
      }
    },

    'filters.cidade': function() {
        if (this.timerCidade) clearTimeout(this.timerCidade);
        
        this.timerCidade = setTimeout(() => {
            this.$_applyQueryString();
        }, 500);
    },
  },
};
</script>

<style scoped>
  .div-geral {
    padding: 16px 12px;
  }

  .primeiro-filtro {
    position: relative;
    opacity: 1;
    z-index: 1;
  }
</style>